import { useSelector } from "react-redux";
export const allLanguages = {
  // English
  GB: {
    myProfile: "My Profile", // Profile (User)
    personalInformation: "Personal Information",
    changePassword: "Change Password",
    premium: "Premium",
    termsAndConditions: "Terms and Conditions",
    aboutUs: "About Us",
    feedback: "Feedback",
    logOut: "Log Out",
    // Sidebar
    home: "Home",
    save: "Save",
    commercials: "Commercials",
    profile: "Profile",
    faq: "FAQ",
    logOut: "Log Out",
    //homes
    hello: "Hello",
    commercialAds: "Commercial Ads here",
    // Saves Page
    saved: "Saved",
    recentlySaved: "Recently Saved",
    visited: "Visited",
    // Commercials Page
    commercials: "Commercials",
    yourCommercials: "Your Commercials",
    mostPopular: "Most Popular",
    recent: "Recent",
    previous: "Previous",
    next: "Next",
    placesNearYou: "Places Near You",
    // FAQs
    "faqQuestion1": "How can I manage multiple locations at once?",
  "faqAnswer1": "Each location can be managed and analyzed individually through My Place.",
  
  "faqQuestion2": "What is the difference between an event and a special event?",
  "faqAnswer2": "An event is a one-time activity that does not take place at an existing location, while a special event is a unique occasion hosted at an existing activity location.",
  
  "faqQuestion3": "How and whom can I notify about my event?",
  "faqAnswer3": "When launching a special event or event, you can use the Push Notification feature to select a specific radius. Users within that radius who have opted in to receive notifications for that activity segment will be informed.",
  
  "faqQuestion4": "What are the benefits of Premium?",
  "faqAnswer4": "With a Premium account, you have unlimited customization options to display various types of discounts on the map, along with the ability to upload engaging videos to promote your activity.",
    //auth
    //login page
    helloAgain: "Hello Again !",
    welcomeTo: "Welcome to",
    rememberMe: "Remember Me",
    forgottenPassword: "Forgotten Password?",
    login: "Login",
    dontHaveAccount: "Don't have an account ?",
    byTappingConfirm: "By tapping confirm , you agree to the",
    termsOfService: "terms of service",
    andPrivacyPolicy: "and privacy policy",
    signUp: "Sign Up",
    //signup screen
    signUpToGetStarted: "Sign Up to get started",
    register: "Register",
    //forgot password
    forgotPasswordTitle: "Forgot Password!",
    enterEmailToSearch:
      "Please enter your email address to search for your account.",
    backToLogin: "Back to login?",
    confirmAction: "Confirm",
    verifyCode: "Verify Code",
    resendCode: "Resend Code",
    confirmCode: "Confirm",
    enterCodeFromEmail: "Enter Code that you received on your email",
    //reset password
    submit: "Submit",
    resetPasswordTitle: "Reset Password!",
    enterNewPassword: "Please enter new password for your account",
    success: "Success",
    formError: "Form Error",
    //contributor screen
    // sidebar
    dashboard: "Dashboard",
    myPlaces: "My Places",
    commercials: "Commercials",
    //dashboard
    analytics: "Analytics",
    profileVisitors: "Profile Visitors",
    customerReviews: "Customer Reviews",
    customerRatio: "Customer Ratio",
    reservations: "Reservations",
    totalVisitors: "Total Visitors",
    thisYear: "This Year",
    thisMonth: "This Month",
    todaysCustomerRatio: "Today's Customer Ratio",
    current: "Current",
    customersReview: "Customers Review",
    vsYesterday: "vs Yesterday",
    //my places
    all: "All",
    approved: "Approved",
    pending: "Pending",
    rejected: "Rejected",
    addNew: "Add new",
    addActivityLocation: "Add activity location",
    addYourEvent: "Add Your Event",
    addSpecialEvent: "Add Special Event",
    editPlace: "Edit Place",
    approvedText: "Approved",
    pendingText: "Pending",
    rejectedText: "Rejected",
    //categories
    adventure: "Adventure",
    kids: "Kids",
    culture: "Culture",
    date: "Date",
    restaurant: "Restaurant",
    sports: "Sports",
    countryFairs: "Country fairs",
    music: "Music",
    learning: "Learning",
    gaming: "Gaming",
    animals: "Animals",
    events: "Events",
    specialEvents: "Special Events",
    filter: "Filter",
    category: "Category",
    hours: "Hours",
    discount: "Discount",
    clear: "Clear",
    apply: "Apply",
    specifyInterest:
      "Please specify your interest for which you want to get notification",
    notifications: "Notifications",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    writeFeedback: "Write your feedback here",
    //terms and condition
    termsTitle1: "Acceptance of Terms",
    termsParagraph1:
      "By using our services, you agree to these terms and conditions. If you do not agree, please do not use our app.",
    termsTitle2: "Changes to Terms",
    termsParagraph2:
      "We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of the app signifies your acceptance of the revised terms.",
    termsTitle3: "User Responsibilities",
    termsParagraph3:
      "Users must use the app responsibly and in compliance with all applicable laws. Any misuse, including but not limited to unauthorized access, dissemination of harmful content, or infringement of intellectual property rights, is prohibited.",
    termsTitle4: "Account Registration",
    termsParagraph4:
      "To access certain features, you may be required to create an account. You agree to provide accurate information and keep your account secure. You are responsible for all activities under your account.",
    termsTitle5: "Privacy",
    termsParagraph5:
      "Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your information. By using the app, you consent to our data practices.",
    termsWelcome:
      "Welcome to Activity Map App. By downloading, accessing, or using our app, you agree to comply with and be bound by the following terms and conditions:",
    //about us
    aboutUsParagraph1:
      "Welcome to Activity Map App, your premier companion for discovering the best locations and events around you. We understand that everyone has unique interests and passions, which is why our app categorizes activities into diverse sections such as Adventure, Kids, Culture, Restaurants, Sports, Learning, Date Ideas, and a variety of Events including Special Events.",
    aboutUsParagraph2:
      "Our mission is to enrich your life by making exploration easy and accessible. Whether you’re a thrill-seeker looking for the next adrenaline rush, a family planning a fun-filled day out, a culture enthusiast seeking enriching experiences, or a foodie on the hunt for the best local cuisine, Activity Map App has something for everyone.",
    aboutUsParagraph3:
      "The app provides detailed information and maps to help you navigate and make the most of your surroundings. Discover nearby adventures, kid-friendly activities, cultural hotspots, sports venues, educational opportunities, romantic date spots, and a wide range of events. Each category is meticulously curated to ensure that you have access to the most relevant and exciting options available.",
    //add place form fields
    addNewPlace: 'Add new Place',
    enterYourPlaceName: "Enter Your Place Name",
    writeNameForPlace: "Write name for place",
    type: "Type",
    reservationLink: "Reservation Link",
    writeReservationLinkHere: "Write reservation link here",
    availability: "Availability",
    selectAvailability: "Select Availability",
    offeredDiscounts: "Offered Discounts",
    selectDiscounts: "Select discounts",
    location: "Location",
    selectLocations: "Select Locations",
    companyName: "Company Name",
    writeCompanyNameHere: "Write company name here",
    billingAddress: "Billing Address",
    genderPreference: "Gender Preference",
    category: "Category",
    enterDescription: "Enter Description",
    writeDescriptionOfPlace: "Write description of place",
    addPhotos: "Add Photos",
    addVideo: "Add Video",
    addMenu: "Add Menu",
    payNow: "Pay Now",
    title: "Title",
    writeTitle: "Write Title",
    price: "Price",
    writeDealPrice: "Write Deal Price",
    startDate: "Start Date",
    selectLocations: "Select Locations",
    selectAvailability: "Select Availability",
    myEvents: "My Events",
    specialEvent: "Special Event",
    specialEventText: 'Special Event: Stands for a Special Event from a activity company which makes a special program at a specific day at their usual location.',
    done: 'Done',
    addYourSpecialEvent: "Add Your Special Event",
    place: "Place",
    close: "Close",
    add: "Add",
    addLocation: "Add Location",
    streetAddress: "Street Address",
    city: "City",
    state: "State/Province",
    zipCode: "Zip Code / Postal Code",
    country: "Country",
    selectCountry: "Select Country",
    selectState: "Select State",
    selectCity: "Select City",
    writeZipCode: "Write Zip Code",
    writeStreetAddress: "Write street address",
    discountOffered: "Discount offered",
    discountForGroups: "Discount for groups",
    specficDay: "Specific day",
    singleUse: "Single use",
    startDate: "Start Date",
    endDate: "End Date",
    selectDate: "Select Date",
    everyDay: "Every Day",
    description: "Description",
    writeDescription: "Write Description",
    addBillingAddress: "Add Billing Address",
    addNewCommercial: "Add new Commercial",
    Commercials: "Commercials",
    enterCommericalsName: "Enter Commericals Name",
    enterYourPlaceName: "Enter Your Place Name",
    types: "Types",
    enterDescription: "Enter Description",
    writeDescription: "Write Description",
    addMedia: "Add Media",
    payNow: "Pay Now",
    pleaseEnterTitle: "Please enter title",
    pleaseEnterItemName: "Please enter item name",
    writeDescription: "Write description",
    writeDealPrice: "Write deal price",
    edit: "Edit",
    resembelanceFor: "Resembelance For",
    availableDiscount: "Available Discount",
    addDeals: "Add Deals",
    discountOn: "Discount On",
    restaurantLatest: "Restaurant Latest",
    bestDeals: "Best Deals",
    forThisPlaceNoDealsAddedYet: "For this place no deals added yet",
    reviews: "Reviews",
    noReviewsAddedYet: "No reviews added yet",
    myPlaces: "My Places",
    price: "Price",
    onEvery: "On Every",
    from: "From",
    bestDeals: "Best Deals",
    event:"Event",
    eventText:"An event is an activity that occurs at some location .They are not related to places and will appear on map"
  },
  // Italian
  IT: {
    myProfile: "Il mio profilo",
    "event": "Evento",
  "eventText": "Un evento è un'attività che si svolge in un luogo. Non è legato a luoghi specifici e apparirà sulla mappa.", // Profilo (Utente)
    personalInformation: "Informazioni personali",
    changePassword: "Cambia la password",
    premium: "Premium",
    termsAndConditions: "Termini e condizioni",
    aboutUs: "Chi siamo",
    feedback: "Feedback",
    logOut: "Disconnettersi",
    // Sidebar
    home: "Home",
    save: "Salva",
    commercials: "Annunci",
    profile: "Profilo",
    faq: "Domande frequenti",
    logOut: "Disconnettersi",
    //home
    hello: "Ciao",
    commercialAds: "Annunci commerciali qui",
    // Saves Page
    save: "Salva",
    recentlySaved: "Salvati di recente",
    visited: "Visitati",
    // Commercials Page
    commercials: "Commerciali",
    yourCommercials: "I tuoi commerciali",
    mostPopular: "I più popolari",
    recent: "Recenti",
    previous: "Precedente",
    next: "Successivo",
    placesNearYou: "Luoghi vicino a te",
    // FAQs
    "faqQuestion1": "Come posso gestire più sedi contemporaneamente?",
  "faqAnswer1": "Ogni sede può essere gestita e analizzata individualmente tramite My Place.",
  
  "faqQuestion2": "Qual è la differenza tra un evento e un evento speciale?",
  "faqAnswer2": "Un evento è un’attività occasionale che non si svolge in una sede esistente, mentre un evento speciale è un’occasione unica ospitata in una sede di attività già esistente.",
  
  "faqQuestion3": "Come e chi posso informare riguardo al mio evento?",
  "faqAnswer3": "Quando lanci un evento o un evento speciale, puoi utilizzare la funzione di Notifica Push per selezionare un raggio specifico. Gli utenti all’interno di quel raggio che hanno scelto di ricevere notifiche per quel segmento di attività verranno informati.",
  
  "faqQuestion4": "Quali sono i vantaggi dell’account Premium?",
  "faqAnswer4": "Con un account Premium, hai opzioni di personalizzazione illimitate per mostrare vari tipi di sconti sulla mappa, oltre alla possibilità di caricare video coinvolgenti per promuovere la tua attività.",
    //auth
    //login page
    helloAgain: "Ciao di nuovo!",
    welcomeTo: "Bentornato",
    rememberMe: "Ricordami",
    forgottenPassword: "Password dimenticata?",
    login: "Accedi",
    dontHaveAccount: "Non hai un account?",
    byTappingConfirm: "Toccando conferma, accetti i",
    termsOfService: "termini di servizio",
    andPrivacyPolicy: "e l'informativa sulla privacy",
    signUp: "Registrati",
    //signup screen
    signUpToGetStarted: "Registrati per iniziare",
    register: "Registrati",
    //forgot password
    forgotPasswordTitle: "Password dimenticata!",
    enterEmailToSearch:
      "Inserisci il tuo indirizzo email per cercare il tuo account.",
    backToLogin: "Torna al login?",
    confirmAction: "Conferma",
    verifyCode: "Verifica codice",
    resendCode: "Reinvia codice",
    confirmCode: "Conferma",
    enterCodeFromEmail: "Inserisci il codice che hai ricevuto via email",
    //reset password
    submit: "Invia",
    resetPasswordTitle: "Reimposta la password!",
    enterNewPassword: "Inserisci una nuova password per il tuo account",
    success: "Successo",
    formError: "Errore nel modulo",
    //contributor screen
    // sidebar
    dashboard: "Dashboard",
    myPlaces: "I miei luoghi",
    commercials: "Annunci",
    //dashboard
    analytics: "Analisi",
    profileVisitors: "Visitatori del profilo",
    customerReviews: "Recensioni dei clienti",
    customerRatio: "Rapporto clienti",
    reservations: "Prenotazioni",
    totalVisitors: "Visitatori totali",
    thisYear: "Quest'anno",
    thisMonth: "Questo mese",
    todaysCustomerRatio: "Rapporto clienti di oggi",
    current: "Attuale",
    customersReview: "Recensione clienti",
    vsYesterday: "rispetto a ieri",
    //my places
    all: "Tutti",
    approved: "Approvato",
    pending: "In attesa",
    rejected: "Rifiutato",
    addNew: "Aggiungi nuovo",
    addActivityLocation: "Aggiungi luogo dell'attività",
    addYourEvent: "Aggiungi il tuo evento",
    addSpecialEvent: "Aggiungi evento speciale",
    editPlace: "Modifica luogo",
    approvedText: "Approvato",
    pendingText: "In attesa",
    rejectedText: "Rifiutato",
    //categories
    adventure: "Avventura",
    kids: "Bambini",
    culture: "Cultura",
    date: "Appuntamento",
    restaurant: "Ristorante",
    sports: "Sport",
    countryFairs: "Fiere di paese",
    music: "Musica",
    learning: "Apprendimento",
    gaming: "Giochi",
    animals: "Animali",
    events: "Eventi",
    specialEvents: "Eventi speciali",
    filter: "Filtro",
    category: "Categoria",
    hours: "Ore",
    discount: "Sconto",
    clear: "Cancella",
    apply: "Applica",
    specifyInterest:
      "Specifica il tuo interesse per il quale desideri ricevere notifiche",
    notifications: "Notifiche",
    currentPassword: "Password attuale",
    newPassword: "Nuova password",
    confirmPassword: "Conferma password",
    writeFeedback: "Scrivi qui il tuo feedback",
    //terms and condition
    termsTitle1: "Accettazione dei Termini",
    termsParagraph1:
      "Utilizzando i nostri servizi, accetti questi termini e condizioni. Se non sei d'accordo, ti preghiamo di non utilizzare la nostra app.",
    termsTitle2: "Modifiche ai Termini",
    termsParagraph2:
      "Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. Le modifiche saranno efficaci immediatamente dopo la pubblicazione. Il tuo continuo utilizzo dell'app significa che accetti i termini revisionati.",
    termsTitle3: "Responsabilità dell'Utente",
    termsParagraph3:
      "Gli utenti devono utilizzare l'app in modo responsabile e in conformità con tutte le leggi applicabili. Qualsiasi uso improprio, incluso ma non limitato a accesso non autorizzato, diffusione di contenuti dannosi o violazione dei diritti di proprietà intellettuale, è vietato.",
    termsTitle4: "Registrazione Account",
    termsParagraph4:
      "Per accedere a determinate funzionalità, potresti dover creare un account. Accetti di fornire informazioni accurate e di mantenere il tuo account sicuro. Sei responsabile di tutte le attività svolte con il tuo account.",
    termsTitle5: "Privacy",
    termsParagraph5:
      "La tua privacy è importante per noi. La nostra Informativa sulla Privacy spiega come raccogliamo, usiamo e proteggiamo le tue informazioni. Utilizzando l'app, acconsenti alle nostre pratiche sui dati.",
    termsWelcome:
      "Benvenuto nell'app Activity Map. Scaricando, accedendo o utilizzando la nostra app, accetti di rispettare e essere vincolato dai seguenti termini e condizioni:",
    //about us
    aboutUsParagraph1:
      "Benvenuto in Activity Map App, il tuo compagno ideale per scoprire i migliori luoghi ed eventi intorno a te. Comprendiamo che ognuno ha interessi e passioni uniche, per questo la nostra app classifica le attività in sezioni diverse come Avventura, Bambini, Cultura, Ristoranti, Sport, Apprendimento, Idee per appuntamenti e una varietà di Eventi, inclusi Eventi Speciali.",
    aboutUsParagraph2:
      "La nostra missione è arricchire la tua vita rendendo l'esplorazione facile e accessibile. Che tu sia un cercatore di emozioni in cerca della prossima scarica di adrenalina, una famiglia che pianifica una giornata divertente, un appassionato di cultura in cerca di esperienze arricchenti, o un buongustaio alla ricerca della migliore cucina locale, Activity Map App ha qualcosa per tutti.",
    aboutUsParagraph3:
      "L'app fornisce informazioni dettagliate e mappe per aiutarti a orientarti e sfruttare al meglio il tuo ambiente. Scopri avventure vicine, attività adatte ai bambini, punti culturali, impianti sportivi, opportunità educative, luoghi romantici per appuntamenti e una vasta gamma di eventi. Ogni categoria è meticolosamente curata per garantirti l'accesso alle opzioni più rilevanti ed entusiasmanti disponibili.",
    //add place form fields
    addNewPlace: 'Aggiungi nuovo luogo',
    enterYourPlaceName: "Inserisci il Nome del Tuo Locale",
    writeNameForPlace: "Scrivi il nome del locale",
    type: "Tipo",
    reservationLink: "Link di Prenotazione",
    writeReservationLinkHere: "Scrivi qui il link di prenotazione",
    availability: "Disponibilità",
    selectAvailability: "Seleziona Disponibilità",
    offeredDiscounts: "Sconti Offerti",
    selectDiscounts: "Seleziona sconti",
    location: "Posizione",
    selectLocations: "Seleziona Posizioni",
    companyName: "Nome Azienda",
    writeCompanyNameHere: "Scrivi qui il nome dell'azienda",
    billingAddress: "Indirizzo di Fatturazione",
    genderPreference: "Preferenza di Genere",
    category: "Categoria",
    enterDescription: "Inserisci Descrizione",
    writeDescriptionOfPlace: "Scrivi la descrizione del locale",
    addPhotos: "Aggiungi Foto",
    addVideo: "Aggiungi Video",
    addMenu: "Aggiungi Menu",
    payNow: "Paga Ora",
    title: "Titolo",
    writeTitle: "Scrivi Titolo",
    price: "Prezzo",
    writeDealPrice: "Scrivi Prezzo dell'Offerta",
    startDate: "Data di Inizio",
    selectLocations: "Seleziona Località",
    selectAvailability: "Seleziona Disponibilità",
    addNewPlace: "Aggiungi nuovo luogo",
    myEvents: "I miei eventi",
    specialEvent: "Evento speciale",
    specialEventText: "Evento speciale: Rappresenta un evento speciale di un'azienda di attività che organizza un programma speciale in un giorno specifico nella loro sede abituale.",
    done: "Fatto",
    addYourSpecialEvent: "Aggiungi il tuo evento speciale",
    place: "Luogo",
    close: "Chiudi",
    add: "Aggiungi",
    addLocation: "Aggiungi posizione",
    streetAddress: "Indirizzo",
    city: "Città",
    state: "Stato/Provincia",
    zipCode: "CAP / Codice Postale",
    country: "Paese",
    selectCountry: "Seleziona Paese",
    selectState: "Seleziona Stato",
    selectCity: "Seleziona Città",
    writeZipCode: "Scrivi CAP",
    writeStreetAddress: "Scrivi indirizzo",
    discountOffered: "Sconto offerto",
    discountForGroups: "Sconto per gruppi",
    specficDay: "Giorno specifico",
    singleUse: "Uso singolo",
    startDate: "Data di inizio",
    endDate: "Data di fine",
    selectDate: "Seleziona data",
    everyDay: "Ogni giorno",
    description: "Descrizione",
    writeDescription: "Scrivi descrizione",
    addNewCommercial: "Aggiungi nuovo Commercial",
    commercial: "Commerciale",
    enterCommercialName: "Inserisci il nome commerciale",
    enterYourPlaceName: "Inserisci il nome del tuo locale",
    types: "Tipi",
    enterDescription: "Inserisci la descrizione",
    writeDescription: "Scrivi la descrizione",
    addMedia: "Aggiungi media",
    payNow: "Paga ora",
    editPhotos: "Modifica foto",
    editVideo: "Modifica video",
    editMenu: "Modifica menu",
    editPlace: "Modifica locale",
    itemName: "Nome dell'articolo",
    from: "Da",
    to: "A",
    picture: "Immagine",
    update: "Aggiorna",
    pleaseEnterTitle: "Per favore inserisci il titolo",
    pleaseEnterItemName: "Per favore inserisci il nome dell'articolo",
    writeDescription: "Scrivi la descrizione",
    writeDealPrice: "Scrivi il prezzo dell'offerta",
    edit: "Modifica",
    resembelanceFor: "Somiglianza per",
    availableDiscount: "Sconto disponibile",
    addDeals: "Aggiungi offerte",
    discountOn: "Sconto su",
    restaurantLatest: "Ultime dal ristorante",
    bestDeals: "Migliori offerte",
    forThisPlaceNoDealsAddedYet: "Per questo locale non sono state ancora aggiunte offerte",
    reviews: "Recensioni",
    noReviewsAddedYet: "Nessuna recensione aggiunta ancora",
    myPlaces: "I miei luoghi",
    price: "Prezzo",
    onEvery: "Ogni",
    from: "Da",
    bestDeals: "Migliori offerte",
    bestDeals: "Migliori offerte",
  },
  // Spanish
  ES: {
    myProfile: "Mi perfil", // Perfil (Usuario)
    "event": "Evento",
    "eventText": "Un evento es una actividad que ocurre en algún lugar. No está relacionado con lugares específicos y aparecerá en el mapa.",

    personalInformation: "Información personal",
    changePassword: "Cambiar la contraseña",
    premium: "Premium",
    termsAndConditions: "Términos y condiciones",
    aboutUs: "Sobre nosotros",
    feedback: "Comentarios",
    logOut: "Cerrar sesión",
    // Sidebar
    home: "Inicio",
    save: "Guardar",
    commercials: "Anuncios",
    profile: "Perfil",
    faq: "Preguntas frecuentes",
    logOut: "Cerrar sesión",
    //home
    hello: "¡Hola",
    commercialAds: "Anuncios comerciales aquí",
    // Saves Page
    save: "Guardar",
    recentlySaved: "Guardado recientemente",
    visited: "Visitado",
    // Commercials Page
    commercials: "Comerciales",
    yourCommercials: "Tus comerciales",
    mostPopular: "Los más populares",
    recent: "Reciente",
    previous: "Anterior",
    next: "Siguiente",
    placesNearYou: "Lugares cerca de ti",
    // FAQs
    "faqQuestion1": "¿Cómo puedo gestionar múltiples ubicaciones a la vez?",
  "faqAnswer1": "Cada ubicación puede gestionarse y analizarse individualmente a través de My Place.",
  
  "faqQuestion2": "¿Cuál es la diferencia entre un evento y un evento especial?",
  "faqAnswer2": "Un evento es una actividad única que no tiene lugar en una ubicación existente, mientras que un evento especial es una ocasión única organizada en un lugar de actividad ya existente.",
  
  "faqQuestion3": "¿Cómo y a quién puedo notificar sobre mi evento?",
  "faqAnswer3": "Al lanzar un evento o un evento especial, puedes usar la función de Notificación Push para seleccionar un radio específico. Los usuarios dentro de ese radio que hayan aceptado recibir notificaciones para ese segmento de actividad serán informados.",
  
  "faqQuestion4": "¿Cuáles son los beneficios de Premium?",
  "faqAnswer4": "Con una cuenta Premium, tienes opciones ilimitadas de personalización para mostrar varios tipos de descuentos en el mapa, junto con la posibilidad de subir videos atractivos para promocionar tu actividad.",
    //auth
    //login page
    helloAgain: "¡Hola de nuevo!",
    welcomeTo: "Bienvenido de nuevo",
    rememberMe: "Recuérdame",
    forgottenPassword: "¿Olvidaste tu contraseña?",
    login: "Iniciar sesión",
    dontHaveAccount: "¿No tienes una cuenta?",
    byTappingConfirm: "Al tocar confirmar, aceptas los",
    termsOfService: "términos del servicio",
    andPrivacyPolicy: "y la política de privacidad",
    signUp: "Regístrate",
    //signup screen
    signUpToGetStarted: "Regístrate para comenzar",
    register: "Registrarse",
    //forgot password
    forgotPasswordTitle: "¡Olvidaste tu contraseña!",
    enterEmailToSearch:
      "Por favor, introduce tu correo electrónico para buscar tu cuenta.",
    backToLogin: "¿Volver al inicio de sesión?",
    confirmAction: "Confirmar",
    verifyCode: "Verificar código",
    resendCode: "Reenviar código",
    confirmCode: "Confirmar",
    enterCodeFromEmail:
      "Ingresa el código que recibiste en tu correo electrónico",
    //reset password
    submit: "Enviar",
    resetPasswordTitle: "¡Restablecer contraseña!",
    enterNewPassword:
      "Por favor, introduce una nueva contraseña para tu cuenta",
    success: "Éxito",
    formError: "Error en el formulario",
    //contributor screen
    // sidebar
    dashboard: "Panel de control",
    myPlaces: "Mis lugares",
    commercials: "Anuncios",
    //dashboard
    analytics: "Análisis",
    profileVisitors: "Visitantes del perfil",
    customerReviews: "Reseñas de clientes",
    customerRatio: "Proporción de clientes",
    reservations: "Reservas",
    totalVisitors: "Visitantes totales",
    thisYear: "Este año",
    thisMonth: "Este mes",
    todaysCustomerRatio: "Proporción de clientes de hoy",
    current: "Actual",
    customersReview: "Reseña de clientes",
    vsYesterday: "vs Ayer",
    //my places
    all: "Todos",
    approved: "Aprobado",
    pending: "Pendiente",
    rejected: "Rechazado",
    addNew: "Agregar nuevo",
    addActivityLocation: "Agregar ubicación de actividad",
    addYourEvent: "Agrega tu evento",
    addSpecialEvent: "Agregar evento especial",
    editPlace: "Editar lugar",
    approvedText: "Aprobado",
    pendingText: "Pendiente",
    rejectedText: "Rechazado",
    //categories
    adventure: "Aventura",
    kids: "Niños",
    culture: "Cultura",
    date: "Cita",
    restaurant: "Restaurante",
    sports: "Deportes",
    countryFairs: "Ferias locales",
    music: "Música",
    learning: "Aprendizaje",
    gaming: "Videojuegos",
    animals: "Animales",
    events: "Eventos",
    specialEvents: "Eventos especiales",
    filter: "Filtrar",
    category: "Categoría",
    hours: "Horas",
    discount: "Descuento",
    clear: "Borrar",
    apply: "Aplicar",
    specifyInterest:
      "Especifica tu interés por el cual deseas recibir notificaciones",
    notifications: "Notificaciones",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    writeFeedback: "Escribe tus comentarios aquí",
    //terms and condition
    termsTitle1: "Aceptación de los Términos",
    termsParagraph1:
      "Al usar nuestros servicios, aceptas estos términos y condiciones. Si no estás de acuerdo, por favor no uses nuestra aplicación.",
    termsTitle2: "Cambios en los Términos",
    termsParagraph2:
      "Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios serán efectivos inmediatamente después de su publicación. El uso continuado de la aplicación significa que aceptas los términos revisados.",
    termsTitle3: "Responsabilidades del Usuario",
    termsParagraph3:
      "Los usuarios deben usar la aplicación de manera responsable y en cumplimiento con todas las leyes aplicables. Se prohíbe cualquier uso indebido, incluyendo pero no limitado al acceso no autorizado, difusión de contenido dañino o infracción de derechos de propiedad intelectual.",
    termsTitle4: "Registro de Cuenta",
    termsParagraph4:
      "Para acceder a ciertas funciones, es posible que debas crear una cuenta. Aceptas proporcionar información precisa y mantener segura tu cuenta. Eres responsable de todas las actividades bajo tu cuenta.",
    termsTitle5: "Privacidad",
    termsParagraph5:
      "Tu privacidad es importante para nosotros. Nuestra Política de Privacidad explica cómo recopilamos, usamos y protegemos tu información. Al usar la aplicación, consientes nuestras prácticas de datos.",
    termsWelcome:
      "Bienvenido a la aplicación Activity Map. Al descargar, acceder o usar nuestra aplicación, aceptas cumplir y estar sujeto a los siguientes términos y condiciones:",
    //about us
    aboutUsParagraph1:
      "Bienvenido a Activity Map App, tu compañero principal para descubrir los mejores lugares y eventos a tu alrededor. Entendemos que cada persona tiene intereses y pasiones únicas, por eso nuestra aplicación categoriza las actividades en secciones diversas como Aventura, Niños, Cultura, Restaurantes, Deportes, Aprendizaje, Ideas para citas y una variedad de Eventos incluyendo Eventos Especiales.",
    aboutUsParagraph2:
      "Nuestra misión es enriquecer tu vida facilitando y haciendo accesible la exploración. Ya seas un buscador de emociones buscando la próxima descarga de adrenalina, una familia planeando un día lleno de diversión, un entusiasta de la cultura buscando experiencias enriquecedoras, o un amante de la comida en busca de la mejor cocina local, Activity Map App tiene algo para todos.",
    aboutUsParagraph3:
      "La aplicación proporciona información detallada y mapas para ayudarte a navegar y aprovechar al máximo tu entorno. Descubre aventuras cercanas, actividades para niños, puntos culturales, lugares deportivos, oportunidades educativas, sitios románticos para citas y una amplia gama de eventos. Cada categoría está cuidadosamente seleccionada para asegurarte acceso a las opciones más relevantes y emocionantes disponibles.",
    // Form fields
    enterYourPlaceName: "Ingresa el Nombre de Tu Lugar",
    writeNameForPlace: "Escribe el nombre del lugar",
    type: "Tipo",
    reservationLink: "Enlace de Reserva",
    writeReservationLinkHere: "Escribe aquí el enlace de reserva",
    availability: "Disponibilidad",
    selectAvailability: "Seleccionar Disponibilidad",
    offeredDiscounts: "Descuentos Ofrecidos",
    selectDiscounts: "Seleccionar descuentos",
    location: "Ubicación",
    selectLocations: "Seleccionar Ubicaciones",
    companyName: "Nombre de la Empresa",
    writeCompanyNameHere: "Escribe aquí el nombre de la empresa",
    billingAddress: "Dirección de Facturación",
    genderPreference: "Preferencia de Género",
    category: "Categoría",
    enterDescription: "Ingresa Descripción",
    writeDescriptionOfPlace: "Escribe la descripción del lugar",
    addPhotos: "Agregar Fotos",
    addVideo: "Agregar Video",
    addMenu: "Agregar Menú",
    payNow: "Pagar Ahora",
    addNewPlace: "Agregar nuevo lugar",
    title: "Título",
    writeTitle: "Escribir Título",
    price: "Precio",
    writeDealPrice: "Escribir Precio de la Oferta",
    startDate: "Fecha de Inicio",
    selectLocations: "Seleccionar Ubicaciones",
    selectAvailability: "Seleccionar Disponibilidad",
    addNewPlace: "Agregar nuevo lugar",
    myEvents: "Mis Eventos",
    specialEvent: "Evento Especial",
    specialEventText: "Evento Especial: Representa un evento especial de una empresa de actividades que organiza un programa especial en un día específico en su ubicación habitual.",
    done: "Hecho",
    addYourSpecialEvent: "Agrega tu Evento Especial",
    place: "Lugar",
    close: "Cerrar",
    add: "Agregar",
    addLocation: "Agregar Ubicación",
    streetAddress: "Dirección",
    city: "Ciudad",
    state: "Estado/Provincia",
    zipCode: "Código Postal",
    country: "País",
    selectCountry: "Seleccionar País",
    selectState: "Seleccionar Estado",
    selectCity: "Seleccionar Ciudad",
    writeZipCode: "Escribir Código Postal",
    writeStreetAddress: "Escribir Dirección",
    discountOffered: "Descuento Ofrecido",
    discountForGroups: "Descuento para Grupos",
    specficDay: "Día Específico",
    singleUse: "Uso Único",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Fin",
    selectDate: "Seleccionar Fecha",
    everyDay: "Todos los Días",
    description: "Descripción",
    writeDescription: "Escribir Descripción",
    addNewCommercial: "Agregar nuevo Commercial",
    commercial: "Comercial",
    enterCommercialName: "Ingrese el nombre comercial",
    enterYourPlaceName: "Ingrese el nombre de su lugar",
    types: "Tipos",
    enterDescription: "Ingrese la descripción",
    writeDescription: "Escriba la descripción",
    addMedia: "Agregar medios",
    payNow: "Pagar ahora",
    editPhotos: "Editar fotos",
    editVideo: "Editar video",
    editMenu: "Editar menú",
    editPlace: "Editar lugar",
    itemName: "Nombre del artículo",
    from: "De",
    to: "A",
    picture: "Imagen",
    update: "Actualizar",
    pleaseEnterTitle: "Por favor ingrese el título",
    pleaseEnterItemName: "Por favor ingrese el nombre del artículo",
    writeDescription: "Escriba la descripción",
    writeDealPrice: "Escriba el precio de la oferta",
    edit: "Editar",
    resembelanceFor: "Similitud para",
    availableDiscount: "Descuento disponible",
    addDeals: "Agregar ofertas",
    discountOn: "Descuento en",
    restaurantLatest: "Último del restaurante",
    bestDeals: "Mejores ofertas",
    forThisPlaceNoDealsAddedYet: "Para este lugar aún no se han agregado ofertas",
    reviews: "Reseñas",
    noReviewsAddedYet: "Aún no se han agregado reseñas",
    myPlaces: "Mis lugares",
    price: "Precio",
    onEvery: "Todo dia",
    from: "De",
    bestDeals: "Mejores ofertas",
  },
  // Brazilian Portuguese
  BR: {
    myProfile: "Meu perfil", // Perfil (Usuário)
    "event": "Evento",
    "eventText": "Um evento é uma atividade que ocorre em algum local. Eles não estão relacionados a lugares e aparecerão no mapa.",

    personalInformation: "Informações pessoais",
    changePassword: "Alterar senha",
    premium: "Premium",
    termsAndConditions: "Termos e condições",
    aboutUs: "Sobre nós",
    feedback: "Feedback",
    logOut: "Sair",
    // Sidebar
    home: "Início",
    save: "Salvar",
    commercials: "Comerciais",
    profile: "Perfil",
    faq: "Perguntas frequentes",
    logOut: "Sair",
    //home
    hello: "Olá",
    commercialAds: "Anúncios comerciais aqui",
    // Saves Page
    save: "Salvar",
    recentlySaved: "Salvos recentemente",
    visited: "Visitados",
    // Commercials Page
    commercials: "Comerciais",
    yourCommercials: "Seus comerciais",
    mostPopular: "Mais populares",
    recent: "Recentes",
    previous: "Anterior",
    next: "Próximo",
    placesNearYou: "Lugares perto de você",
    // FAQs
    "faqQuestion1": "Como posso gerenciar vários locais ao mesmo tempo?",
    "faqAnswer1": "Cada local pode ser gerenciado e analisado individualmente através do My Place.",
    
    "faqQuestion2": "Qual é a diferença entre um evento e um evento especial?",
    "faqAnswer2": "Um evento é uma atividade única que não ocorre em um local existente, enquanto um evento especial é uma ocasião única realizada em um local de atividade já existente.",
    
    "faqQuestion3": "Como e quem posso notificar sobre meu evento?",
    "faqAnswer3": "Ao lançar um evento ou evento especial, você pode usar o recurso de Notificação Push para selecionar um raio específico. Os usuários dentro desse raio que optaram por receber notificações para esse segmento de atividade serão informados.",
    
    "faqQuestion4": "Quais são os benefícios do Premium?",
    "faqAnswer4": "Com uma conta Premium, você tem opções ilimitadas de personalização para exibir vários tipos de descontos no mapa, além da possibilidade de enviar vídeos envolventes para promover sua atividade.",
    //auth
    //login
    helloAgain: "Olá novamente!",
    welcomeTo: "Bem-vindo de volta",
    rememberMe: "Lembrar-me",
    forgottenPassword: "Esqueceu a senha?",
    login: "Entrar",
    dontHaveAccount: "Não tem uma conta?",
    byTappingConfirm: "Ao tocar em confirmar, você concorda com os",
    termsOfService: "termos de serviço",
    andPrivacyPolicy: "e a política de privacidade",
    signUp: "Cadastrar-se",
    //signup screen
    signUpToGetStarted: "Cadastre-se para começar",
    register: "Registrar",
    //forgot password
    forgotPasswordTitle: "Esqueceu a senha!",
    enterEmailToSearch: "Digite seu e-mail para procurar sua conta.",
    backToLogin: "Voltar para o login?",
    confirmAction: "Confirmar",
    verifyCode: "Verificar código",
    resendCode: "Reenviar código",
    confirmCode: "Confirmar",
    enterCodeFromEmail: "Digite o código que você recebeu no seu e-mail",
    //reset password
    submit: "Enviar",
    resetPasswordTitle: "Redefinir senha!",
    enterNewPassword: "Digite uma nova senha para sua conta",
    success: "Sucesso",
    formError: "Erro no formulário",
    //contributor screen
    // sidebar
    dashboard: "Painel",
    myPlaces: "Meus lugares",
    commercials: "Comerciais",
    //dashboard
    analytics: "Análise",
    profileVisitors: "Visitantes do perfil",
    customerReviews: "Avaliações dos clientes",
    customerRatio: "Proporção de clientes",
    reservations: "Reservas",
    totalVisitors: "Total de visitantes",
    thisYear: "Este ano",
    thisMonth: "Este mês",
    todaysCustomerRatio: "Proporção de clientes de hoje",
    current: "Atual",
    customersReview: "Avaliação de clientes",
    vsYesterday: "vs Ontem",
    //my places
    all: "Todos",
    approved: "Aprovado",
    pending: "Pendente",
    rejected: "Rejeitado",
    addNew: "Adicionar novo",
    addActivityLocation: "Adicionar local da atividade",
    addYourEvent: "Adicione seu evento",
    addSpecialEvent: "Adicionar evento especial",
    editPlace: "Editar local",
    approvedText: "Aprovado",
    pendingText: "Pendente",
    rejectedText: "Rejeitado",
    //categories
    adventure: "Aventura",
    kids: "Crianças",
    culture: "Cultura",
    date: "Encontro",
    restaurant: "Restaurante",
    sports: "Esportes",
    countryFairs: "Feiras regionais",
    music: "Música",
    learning: "Aprendizado",
    gaming: "Jogos",
    animals: "Animais",
    events: "Eventos",
    specialEvents: "Eventos especiais",
    filter: "Filtro",
    category: "Categoria",
    hours: "Horas",
    discount: "Desconto",
    clear: "Limpar",
    apply: "Aplicar",
    specifyInterest:
      "Especifique seu interesse para o qual deseja receber notificações",
    notifications: "Notificações",
    currentPassword: "Senha atual",
    newPassword: "Nova senha",
    confirmPassword: "Confirmar senha",
    writeFeedback: "Escreva seu feedback aqui",
    //terms and condition
    termsTitle1: "Aceitação dos Termos",
    termsParagraph1:
      "Ao usar nossos serviços, você concorda com estes termos e condições. Se não concordar, por favor, não use nosso aplicativo.",
    termsTitle2: "Alterações nos Termos",
    termsParagraph2:
      "Reservamo-nos o direito de modificar estes termos a qualquer momento. As mudanças serão efetivas imediatamente após a publicação. O uso contínuo do aplicativo significa que você aceita os termos revisados.",
    termsTitle3: "Responsabilidades do Usuário",
    termsParagraph3:
      "Os usuários devem usar o aplicativo de forma responsável e em conformidade com todas as leis aplicáveis. Qualquer uso indevido, incluindo mas não limitado ao acesso não autorizado, disseminação de conteúdo prejudicial ou violação dos direitos de propriedade intelectual, é proibido.",
    termsTitle4: "Registro de Conta",
    termsParagraph4:
      "Para acessar certos recursos, você pode precisar criar uma conta. Você concorda em fornecer informações precisas e manter sua conta segura. Você é responsável por todas as atividades na sua conta.",
    termsTitle5: "Privacidade",
    termsParagraph5:
      "Sua privacidade é importante para nós. Nossa Política de Privacidade explica como coletamos, usamos e protegemos suas informações. Ao usar o aplicativo, você consente com nossas práticas de dados.",
    termsWelcome:
      "Bem-vindo ao Activity Map App. Ao baixar, acessar ou usar nosso aplicativo, você concorda em cumprir e estar sujeito aos seguintes termos e condições:",
    //about us
    aboutUsParagraph1:
      "Bem-vindo ao Activity Map App, seu principal companheiro para descobrir os melhores locais e eventos ao seu redor. Entendemos que todos têm interesses e paixões únicos, por isso nosso aplicativo categoriza as atividades em diversas seções como Aventura, Crianças, Cultura, Restaurantes, Esportes, Aprendizado, Ideias para encontros e uma variedade de Eventos, incluindo Eventos Especiais.",
    aboutUsParagraph2:
      "Nossa missão é enriquecer sua vida tornando a exploração fácil e acessível. Seja você um caçador de emoções procurando a próxima descarga de adrenalina, uma família planejando um dia cheio de diversão, um entusiasta da cultura buscando experiências enriquecedoras, ou um amante da gastronomia em busca da melhor culinária local, o Activity Map App tem algo para todos.",
    aboutUsParagraph3:
      "O aplicativo fornece informações detalhadas e mapas para ajudá-lo a navegar e aproveitar ao máximo seu entorno. Descubra aventuras próximas, atividades para crianças, pontos culturais, locais esportivos, oportunidades educacionais, locais românticos para encontros e uma ampla variedade de eventos. Cada categoria é cuidadosamente selecionada para garantir que você tenha acesso às opções mais relevantes e empolgantes disponíveis.",
    // Form fields
    enterYourPlaceName: "Digite o Nome do Seu Local",
    writeNameForPlace: "Escreva o nome do local",
    type: "Tipo",
    reservationLink: "Link de Reserva",
    writeReservationLinkHere: "Escreva aqui o link de reserva",
    availability: "Disponibilidade",
    selectAvailability: "Selecionar Disponibilidade",
    offeredDiscounts: "Descontos Oferecidos",
    selectDiscounts: "Selecionar descontos",
    location: "Localização",
    selectLocations: "Selecionar Localizações",
    companyName: "Nome da Empresa",
    writeCompanyNameHere: "Escreva aqui o nome da empresa",
    billingAddress: "Endereço de Cobrança",
    genderPreference: "Preferência de Gênero",
    category: "Categoria",
    enterDescription: "Digite a Descrição",
    writeDescriptionOfPlace: "Escreva a descrição do local",
    addPhotos: "Adicionar Fotos",
    addVideo: "Adicionar Vídeo",
    addMenu: "Adicionar Cardápio",
    payNow: "Pagar Agora",
    addNewPlace: "Adicionar novo local",
    title: "Título",
    writeTitle: "Escrever Título",
    price: "Preço",
    writeDealPrice: "Escrever Preço da Oferta",
    startDate: "Data de Início",
    selectLocations: "Selecionar Localizações",
    selectAvailability: "Selecionar Disponibilidade",
    addNewPlace: "Adicionar novo lugar",
    myEvents: "Meus Eventos",
    specialEvent: "Evento Especial",
    specialEventText: "Evento Especial: Representa um evento especial de uma empresa de atividades que organiza um programa especial em um dia específico em sua localização habitual.",
    done: "Feito",
    addYourSpecialEvent: "Adicione seu Evento Especial",
    place: "Local",
    close: "Fechar",
    add: "Adicionar",
    addLocation: "Adicionar Localização",
    streetAddress: "Endereço",
    city: "Cidade",
    state: "Estado/Província",
    zipCode: "CEP / Código Postal",
    country: "País",
    selectCountry: "Selecionar País",
    selectState: "Selecionar Estado",
    selectCity: "Selecionar Cidade",
    writeZipCode: "Escrever CEP",
    writeStreetAddress: "Escrever Endereço",
    discountOffered: "Desconto Oferecido",
    discountForGroups: "Desconto para Grupos",
    specficDay: "Dia Específico",
    singleUse: "Uso Único",
    startDate: "Data de Início",
    endDate: "Data de Término",
    selectDate: "Selecionar Data",
    everyDay: "Todos os Dias",
    description: "Descrição",
    writeDescription: "Escrever Descrição",
    commercial: "Comercial",
    enterCommercialName: "Insira o nome comercial",
    enterYourPlaceName: "Insira o nome do seu local",
    types: "Tipos",
    enterDescription: "Insira a descrição",
    writeDescription: "Escreva a descrição",
    addMedia: "Adicionar mídia",
    payNow: "Pagar agora",
    editPhotos: "Editar fotos",
    editVideo: "Editar vídeo",
    editMenu: "Editar menu",
    editPlace: "Editar local",
    itemName: "Nome do item",
    from: "De",
    to: "Até",
    picture: "Imagem",
    update: "Atualizar",
    pleaseEnterTitle: "Por favor insira o título",
    pleaseEnterItemName: "Por favor insira o nome do item",
    writeDescription: "Escreva a descrição",
    writeDealPrice: "Escreva o preço da oferta",
    edit: "Editar",
    resembelanceFor: "Semelhança para",
    availableDiscount: "Desconto disponível",
    addDeals: "Adicionar ofertas",
    discountOn: "Desconto em",
    restaurantLatest: "Últimas do restaurante",
    bestDeals: "Melhores ofertas",
    forThisPlaceNoDealsAddedYet: "Ainda não foram adicionadas ofertas para este local",
    reviews: "Avaliações",
    noReviewsAddedYet: "Nenhuma avaliação adicionada ainda",
    myPlaces: "Meus lugares",
    price: "Preço",
    onEvery: "Todo dia",
    from: "De",
    bestDeals: "Melhores ofertas",
  },
  // European Portuguese
  PT: {
    myProfile: "O meu perfil", // Perfil (Utilizador)
    personalInformation: "Informações pessoais",
    "event": "Evento",
  "eventText": "Um evento é uma atividade que ocorre num determinado local. Não está relacionado com lugares e aparecerá no mapa.",

    changePassword: "Alterar palavra-passe",
    premium: "Premium",
    termsAndConditions: "Termos e condições",
    aboutUs: "Sobre nós",
    feedback: "Comentários",
    logOut: "Terminar sessão",
    // Sidebar
    home: "Início",
    save: "Guardar",
    commercials: "Comerciais",
    profile: "Perfil",
    faq: "Perguntas frequentes",
    logOut: "Terminar sessão",
    //home
    hello: "Olá",
    commercialAds: "Anúncios comerciais aqui",
    // Saves Page
    save: "Guardar",
    recentlySaved: "Recentemente guardados",
    visited: "Visitados",
    // Commercials Page
    commercials: "Comerciais",
    yourCommercials: "Os seus comerciais",
    mostPopular: "Mais populares",
    recent: "Recentes",
    previous: "Anterior",
    next: "Próximo",
    placesNearYou: "Lugares perto de si",
    // FAQs
    "faqQuestion1": "Como posso gerir vários locais ao mesmo tempo?",
    "faqAnswer1": "Cada local pode ser gerido e analisado individualmente através do My Place.",
    
    "faqQuestion2": "Qual é a diferença entre um evento e um evento especial?",
    "faqAnswer2": "Um evento é uma atividade pontual que não ocorre num local existente, enquanto um evento especial é uma ocasião única realizada num local de atividade já existente.",
    
    "faqQuestion3": "Como e quem posso notificar sobre o meu evento?",
    "faqAnswer3": "Ao lançar um evento ou evento especial, pode utilizar a funcionalidade de Notificação Push para selecionar um raio específico. Os utilizadores dentro desse raio que optaram por receber notificações para esse segmento de atividade serão informados.",
    
    "faqQuestion4": "Quais são os benefícios da conta Premium?",
    "faqAnswer4": "Com uma conta Premium, tem opções ilimitadas de personalização para mostrar vários tipos de descontos no mapa, bem como a possibilidade de carregar vídeos cativantes para promover a sua atividade.",
    //auth
    //login
    helloAgain: "Olá novamente!",
    welcomeTo: "Bem-vindo de volta",
    rememberMe: "Lembrar-me",
    forgottenPassword: "Esqueceu-se da palavra-passe?",
    login: "Iniciar sessão",
    dontHaveAccount: "Não tem uma conta?",
    byTappingConfirm: "Ao tocar em confirmar, concorda com os",
    termsOfService: "termos de serviço",
    andPrivacyPolicy: "e a política de privacidade",
    signUp: "Registar-se",
    //signup screen
    signUpToGetStarted: "Registe-se para começar",
    register: "Registar",
    //forgot password
    forgotPasswordTitle: "Esqueceu-se da palavra-passe!",
    enterEmailToSearch: "Introduza o seu e-mail para procurar a sua conta.",
    backToLogin: "Voltar ao login?",
    confirmAction: "Confirmar",
    verifyCode: "Verificar código",
    resendCode: "Reenviar código",
    confirmCode: "Confirmar",
    enterCodeFromEmail: "Introduza o código que recebeu no seu e-mail",
    //reset password
    submit: "Submeter",
    resetPasswordTitle: "Redefinir palavra-passe!",
    enterNewPassword:
      "Por favor, introduza uma nova palavra-passe para a sua conta",
    success: "Sucesso",
    formError: "Erro no formulário",
    //contributor screen
    // sidebar
    dashboard: "Painel de controlo",
    myPlaces: "Os meus lugares",
    commercials: "Comerciais",
    //dashboard
    analytics: "Análise",
    profileVisitors: "Visitantes do perfil",
    customerReviews: "Avaliações dos clientes",
    customerRatio: "Rácio de clientes",
    reservations: "Reservas",
    totalVisitors: "Visitantes totais",
    thisYear: "Este ano",
    thisMonth: "Este mês",
    todaysCustomerRatio: "Rácio de clientes de hoje",
    current: "Atual",
    customersReview: "Avaliação dos clientes",
    vsYesterday: "vs Ontem",
    //my places
    all: "Todos",
    approved: "Aprovado",
    pending: "Pendente",
    rejected: "Rejeitado",
    addNew: "Adicionar novo",
    addActivityLocation: "Adicionar local de atividade",
    addYourEvent: "Adicione o seu evento",
    addSpecialEvent: "Adicionar evento especial",
    editPlace: "Editar local",
    approvedText: "Aprovado",
    pendingText: "Pendente",
    rejectedText: "Rejeitado",
    //categories
    adventure: "Aventura",
    kids: "Crianças",
    culture: "Cultura",
    date: "Encontro",
    restaurant: "Restaurante",
    sports: "Desporto",
    countryFairs: "Feiras locais",
    music: "Música",
    learning: "Aprendizagem",
    gaming: "Jogos",
    animals: "Animais",
    events: "Eventos",
    specialEvents: "Eventos especiais",
    filter: "Filtro",
    category: "Categoria",
    hours: "Horas",
    discount: "Desconto",
    clear: "Limpar",
    apply: "Aplicar",
    specifyInterest:
      "Especifique o seu interesse para o qual deseja receber notificações",
    notifications: "Notificações",
    currentPassword: "Palavra-passe atual",
    newPassword: "Nova palavra-passe",
    confirmPassword: "Confirmar palavra-passe",
    writeFeedback: "Escreva aqui o seu feedback",
    //terms and condition
    termsTitle1: "Aceitação dos Termos",
    termsParagraph1:
      "Ao usar os nossos serviços, você concorda com estes termos e condições. Se não concordar, por favor, não utilize a nossa aplicação.",
    termsTitle2: "Alterações aos Termos",
    termsParagraph2:
      "Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações serão eficazes imediatamente após a publicação. A sua continuação no uso da aplicação significa que aceita os termos revistos.",
    termsTitle3: "Responsabilidades do Utilizador",
    termsParagraph3:
      "Os utilizadores devem usar a aplicação de forma responsável e em conformidade com todas as leis aplicáveis. Qualquer uso indevido, incluindo mas não limitado ao acesso não autorizado, disseminação de conteúdos nocivos ou violação de direitos de propriedade intelectual, é proibido.",
    termsTitle4: "Registo de Conta",
    termsParagraph4:
      "Para aceder a certas funcionalidades, pode ser necessário criar uma conta. Concorda em fornecer informações precisas e manter a sua conta segura. É responsável por todas as atividades na sua conta.",
    termsTitle5: "Privacidade",
    termsParagraph5:
      "A sua privacidade é importante para nós. A nossa Política de Privacidade explica como recolhemos, usamos e protegemos a sua informação. Ao usar a aplicação, consente nas nossas práticas de dados.",
    termsWelcome:
      "Bem-vindo ao aplicativo Activity Map. Ao baixar, acessar ou usar nosso aplicativo, você concorda em cumprir e estar vinculado aos seguintes termos e condições:",
    aboutUsParagraph1:
      "Bem-vindo ao Activity Map App, seu principal companheiro para descobrir os melhores locais e eventos ao seu redor. Entendemos que cada pessoa tem interesses e paixões únicos, por isso nosso aplicativo categoriza as atividades em diversas seções, como Aventura, Crianças, Cultura, Restaurantes, Esportes, Aprendizado, Ideias para encontros e uma variedade de Eventos, incluindo Eventos Especiais.",
    aboutUsParagraph2:
      "Nossa missão é enriquecer sua vida tornando a exploração fácil e acessível. Seja você um buscador de emoções procurando a próxima descarga de adrenalina, uma família planejando um dia cheio de diversão, um entusiasta da cultura buscando experiências enriquecedoras, ou um amante da gastronomia em busca da melhor culinária local, o Activity Map App tem algo para todos.",
    aboutUsParagraph3:
      "O aplicativo fornece informações detalhadas e mapas para ajudá-lo a navegar e aproveitar ao máximo seu entorno. Descubra aventuras próximas, atividades para crianças, pontos culturais, locais esportivos, oportunidades educacionais, locais românticos para encontros e uma ampla variedade de eventos. Cada categoria é cuidadosamente selecionada para garantir que você tenha acesso às opções mais relevantes e empolgantes disponíveis.",
    // Form fields
    enterYourPlaceName: "Introduza o Nome do Seu Local",
    writeNameForPlace: "Escreva o nome do local",
    type: "Tipo",
    reservationLink: "Link de Reserva",
    writeReservationLinkHere: "Escreva aqui o link de reserva",
    availability: "Disponibilidade",
    selectAvailability: "Selecionar Disponibilidade",
    offeredDiscounts: "Descontos Oferecidos",
    selectDiscounts: "Selecionar descontos",
    location: "Localização",
    selectLocations: "Selecionar Localizações",
    companyName: "Nome da Empresa",
    writeCompanyNameHere: "Escreva aqui o nome da empresa",
    billingAddress: "Morada de Faturação",
    genderPreference: "Preferência de Género",
    category: "Categoria",
    enterDescription: "Introduzir Descrição",
    writeDescriptionOfPlace: "Escreva a descrição do local",
    addPhotos: "Adicionar Fotos",
    addVideo: "Adicionar Vídeo",
    addMenu: "Adicionar Menu",
    payNow: "Pagar Agora",
    addNewPlace: "Adicionar Novo Local",
    title: "Título",
    writeTitle: "Escrever Título",
    price: "Preço",
    writeDealPrice: "Escrever Preço da Oferta",
    startDate: "Data de Início",
    selectLocations: "Selecionar Localizações",
    selectAvailability: "Selecionar Disponibilidade",
    addNewPlace: "Adicionar novo local",
    myEvents: "Meus Eventos",
    specialEvent: "Evento Especial",
    specialEventText: "Evento Especial: Representa um evento especial de uma empresa de atividades que organiza um programa especial em um dia específico em sua localização habitual.",
    done: "Feito",
    addYourSpecialEvent: "Adicione o seu Evento Especial",
    place: "Local",
    close: "Fechar",
    add: "Adicionar",
    addLocation: "Adicionar Localização",
    streetAddress: "Morada",
    city: "Cidade",
    state: "Estado/Província",
    zipCode: "Código Postal",
    writeZipCode: "Escreva o Código Postal",
    country: "País",
    selectCountry: "SSelecionar o País",
    selectState: "Selecionar o Estado",
    selectCity: "Selecionar a Cidade",
    writeStreetAddress: "Escrever Morada",
    discountOffered: "Desconto Oferecido",
    discountForGroups: "Desconto para Grupos",
    specficDay: "Dia Específico",
    singleUse: "Uso Único",
    startDate: "Data de Início",
    endDate: "Data de Fim",
    selectDate: "Selecionar Data",
    everyDay: "Todos os Dias",
    description: "Descrição",
    writeDescription: "Escrever Descrição",
    addNewCommercial: "Adicionar novo Commercial",
    // generate in FT lanugage file
    Commercials: "Comerciais",
    enterCommericalsName: "Digite o nome dos Comerciais",
    enterYourPlaceName: "Digite o nome do seu lugar",
    types: "Tipos",
    enterDescription: "Digite a descrição",
    writeDescription: "Escreva a descrição",
    addMedia: "Adicionar Mídia",
    payNow: "Pagar Agora",
    editPhotos: "Editar Fotos",
    editVideo: "Editar Video",
    editMenu: "Editar Menu",
    editPlace: "Editar Lugar",
    itemName: "Nombre del Item",
    from: "Desde",
    to: "Hasta",
    picture: "Foto",
    update: "Actualizar",
    writeDealPrice: "Escrever Preço da Oferta",
    deal: "Oferta",
    editDeal: "Editar Oferta",
    pleaseEnterTitle: "Por favor, insira o título",
    pleaseEnterItemName: "Por favor, insira o nome do item",
    writeDescription: "Escreva a descrição",
    writeDealPrice: "Escrever Preço da Oferta",
    pleaseEnterTitle: "Por favor, insira o título",
    pleaseEnterItemName: "Por favor, insira o nome do item",
    writeDescription: "Escreva a descrição",
    writeDealPrice: "Escrever Preço da Oferta",
    commercial: "Comercial",
    enterCommercialName: "Introduza o nome comercial",
    enterYourPlaceName: "Introduza o nome do seu local",
    types: "Tipos",
    enterDescription: "Introduza a descrição",
    writeDescription: "Escreva a descrição",
    addMedia: "Adicionar multimédia",
    payNow: "Pagar agora",
    editPhotos: "Editar fotos",
    editVideo: "Editar vídeo",
    editMenu: "Editar menu",
    editPlace: "Editar local",
    itemName: "Nome do artigo",
    from: "De",
    to: "Até",
    picture: "Imagem",
    update: "Atualizar",
    pleaseEnterTitle: "Por favor introduza o título",
    pleaseEnterItemName: "Por favor introduza o nome do artigo",
    writeDescription: "Escreva a descrição",
    writeDealPrice: "Escreva o preço da promoção",
    edit: "Editar",
    resembelanceFor: "Semelhança para",
    availableDiscount: "Desconto disponível",
    addDeals: "Adicionar promoções",
    discountOn: "Desconto em",
    restaurantLatest: "Últimas do restaurante",
    bestDeals: "Melhores promoções",
    forThisPlaceNoDealsAddedYet: "Ainda não foram adicionadas promoções para este local",
    reviews: "Avaliações",
    noReviewsAddedYet: "Ainda não foram adicionadas avaliações",
    myPlaces: "Meus lugares",
    price: "Preço",
    onEvery: "Todo dia",
    from: "De",
    bestDeals: "Melhores promoções",
  },
  // French
  FR: {
    myProfile: "Mon profil", 
    "event": "Événement",
    "eventText": "Un événement est une activité qui se déroule à un certain endroit. Il n'est pas lié à des lieux spécifiques et apparaîtra sur la carte.",
    // Profil (Utilisateur)
    personalInformation: "Informations personnelles",
    changePassword: "Changer le mot de passe",
    premium: "Premium",
    termsAndConditions: "Termes et conditions",
    aboutUs: "À propos de nous",
    feedback: "Retour d'information",
    logOut: "Se déconnecter",
    // Sidebar
    home: "Accueil",
    save: "Enregistrer",
    commercials: "Annonces",
    profile: "Profil",
    faq: "Foire aux questions",
    logOut: "Se déconnecter",
    //home
    hello: "Bonjour ",
    commercialAds: "Publicités commerciales ici",
    // Saves Page
    saved: "Enregistré",
    recentlySaved: "Enregistré récemment",
    visited: "Visité",
    itemName: "Nom de l'Item",
    from: "De",
    to: "À",
    picture: "Photo",
    update: "Mettre à jour",
    // Commercials Page
    commercials: "Publicités",
    yourCommercials: "Vos publicités",
    mostPopular: "Les plus populaires",
    recent: "Récent",
    previous: "Précédent",
    next: "Suivant",
    placesNearYou: "Lieux près de chez vous",
    // FAQs
    "faqQuestion1": "Comment puis-je gérer plusieurs emplacements à la fois ?",
    "faqAnswer1": "Chaque emplacement peut être géré et analysé individuellement via My Place.",
    
    "faqQuestion2": "Quelle est la différence entre un événement et un événement spécial ?",
    "faqAnswer2": "Un événement est une activité ponctuelle qui ne se déroule pas dans un lieu existant, tandis qu’un événement spécial est une occasion unique organisée dans un lieu d’activité déjà existant.",
    
    "faqQuestion3": "Comment et qui puis-je informer à propos de mon événement ?",
    "faqAnswer3": "Lors du lancement d’un événement ou d’un événement spécial, vous pouvez utiliser la fonction de notification Push pour sélectionner un rayon spécifique. Les utilisateurs situés dans ce rayon et ayant choisi de recevoir des notifications pour ce segment d’activité seront informés.",
    
    "faqQuestion4": "Quels sont les avantages du compte Premium ?",
    "faqAnswer4": "Avec un compte Premium, vous disposez d’options de personnalisation illimitées pour afficher différents types de réductions sur la carte, ainsi que de la possibilité de télécharger des vidéos attrayantes pour promouvoir votre activité.",
    //auth
    //login
    helloAgain: "Bonjour à nouveau !",
    welcomeTo: "Bon retour",
    rememberMe: "Se souvenir de moi",
    forgottenPassword: "Mot de passe oublié ?",
    login: "Connexion",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    byTappingConfirm: "En appuyant sur confirmer, vous acceptez les",
    termsOfService: "conditions d'utilisation",
    andPrivacyPolicy: "et la politique de confidentialité",
    signUp: "S'inscrire",
    //signup screen
    signUpToGetStarted: "Inscrivez-vous pour commencer",
    register: "S'inscrire",
    //forgot password
    forgotPasswordTitle: "Mot de passe oublié !",
    enterEmailToSearch:
      "Veuillez entrer votre adresse e-mail pour rechercher votre compte.",
    backToLogin: "Retour à la connexion ?",
    confirmAction: "Confirmer",
    verifyCode: "Vérifier le code",
    resendCode: "Renvoyer le code",
    confirmCode: "Confirmer",
    enterCodeFromEmail: "Entrez le code que vous avez reçu par e-mail",
    //reset password
    submit: "Soumettre",
    resetPasswordTitle: "Réinitialiser le mot de passe !",
    enterNewPassword:
      "Veuillez entrer un nouveau mot de passe pour votre compte",
    success: "Succès",
    formError: "Erreur de formulaire",
    //contributor screen
    // sidebar
    dashboard: "Tableau de bord",
    myPlaces: "Mes lieux",
    commercials: "Publicités",
    //dashboard
    analytics: "Analytique",
    profileVisitors: "Visiteurs du profil",
    customerReviews: "Avis des clients",
    customerRatio: "Ratio de clients",
    reservations: "Réservations",
    totalVisitors: "Visiteurs totaux",
    thisYear: "Cette année",
    thisMonth: "Ce mois-ci",
    todaysCustomerRatio: "Ratio de clients d'aujourd'hui",
    current: "Actuel",
    customersReview: "Avis des clients",
    vsYesterday: "par rapport à hier",
    //my places
    all: "Tous",
    approved: "Approuvé",
    pending: "En attente",
    rejected: "Rejeté",
    addNew: "Ajouter nouveau",
    addActivityLocation: "Ajouter un lieu d'activité",
    addYourEvent: "Ajoutez votre événement",
    addSpecialEvent: "Ajouter un événement spécial",
    editPlace: "Modifier le lieu",
    approvedText: "Approuvé",
    pendingText: "En attente",
    rejectedText: "Rejeté",
    //categories
    adventure: "Aventure",
    kids: "Enfants",
    culture: "Culture",
    date: "Rendez-vous",
    restaurant: "Restaurant",
    sports: "Sports",
    countryFairs: "Foires locales",
    music: "Musique",
    learning: "Apprentissage",
    gaming: "Jeux vidéo",
    animals: "Animaux",
    events: "Événements",
    specialEvents: "Événements spéciaux",
    filter: "Filtrer",
    category: "Catégorie",
    hours: "Heures",
    discount: "Réduction",
    clear: "Effacer",
    apply: "Appliquer",
    specifyInterest:
      "Veuillez spécifier votre intérêt pour lequel vous souhaitez recevoir des notifications",
    notifications: "Notifications",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    writeFeedback: "Écrivez vos commentaires ici",
    //terms and condition
    termsTitle1: "Acceptation des Conditions",
    termsParagraph1:
      "En utilisant nos services, vous acceptez ces termes et conditions. Si vous n'êtes pas d'accord, veuillez ne pas utiliser notre application.",
    termsTitle2: "Modifications des Conditions",
    termsParagraph2:
      "Nous nous réservons le droit de modifier ces termes à tout moment. Les modifications prendront effet immédiatement après leur publication. Votre utilisation continue de l'application signifie que vous acceptez les termes révisés.",
    termsTitle3: "Responsabilités de l'Utilisateur",
    termsParagraph3:
      "Les utilisateurs doivent utiliser l'application de manière responsable et en conformité avec toutes les lois applicables. Toute mauvaise utilisation, y compris mais sans s'y limiter, l'accès non autorisé, la diffusion de contenu nuisible ou la violation des droits de propriété intellectuelle, est interdite.",
    termsTitle4: "Enregistrement du Compte",
    termsParagraph4:
      "Pour accéder à certaines fonctionnalités, vous pouvez être amené à créer un compte. Vous acceptez de fournir des informations exactes et de garder votre compte sécurisé. Vous êtes responsable de toutes les activités effectuées sous votre compte.",
    termsTitle5: "Confidentialité",
    termsParagraph5:
      "Votre vie privée est importante pour nous. Notre politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations. En utilisant l'application, vous consentez à nos pratiques en matière de données.",
    termsWelcome:
      "Bienvenue dans l'application Activity Map. En téléchargeant, accédant ou utilisant notre application, vous acceptez de respecter et d'être lié par les termes et conditions suivants :",
    //about us
    aboutUsParagraph1:
      "Bienvenue dans l'application Activity Map, votre compagnon idéal pour découvrir les meilleurs endroits et événements autour de vous. Nous comprenons que chacun a des intérêts et des passions uniques, c'est pourquoi notre application catégorise les activités en diverses sections telles que Aventure, Enfants, Culture, Restaurants, Sports, Apprentissage, Idées de rendez-vous et une variété d'événements, y compris des événements spéciaux.",
    aboutUsParagraph2:
      "Notre mission est d'enrichir votre vie en rendant l'exploration facile et accessible. Que vous soyez un chercheur de sensations à la recherche de la prochaine montée d'adrénaline, une famille planifiant une journée amusante, un passionné de culture cherchant des expériences enrichissantes, ou un gourmet à la recherche de la meilleure cuisine locale, Activity Map App a quelque chose pour tout le monde.",
    aboutUsParagraph3:
      "L'application fournit des informations détaillées et des cartes pour vous aider à naviguer et à tirer le meilleur parti de votre environnement. Découvrez des aventures à proximité, des activités adaptées aux enfants, des points culturels, des installations sportives, des opportunités éducatives, des lieux romantiques pour les rendez-vous et une large gamme d'événements. Chaque catégorie est méticuleusement sélectionnée pour vous garantir l'accès aux options les plus pertinentes et les plus excitantes disponibles.",
    // Form fields
    enterYourPlaceName: "Saisissez le Nom de Votre Lieu",
    writeNameForPlace: "Écrivez le nom du lieu",
    type: "Type",
    reservationLink: "Lien de Réservation",
    writeReservationLinkHere: "Écrivez ici le lien de réservation",
    availability: "Disponibilité",
    selectAvailability: "Sélectionner la Disponibilité",
    offeredDiscounts: "Remises Offertes",
    selectDiscounts: "Sélectionner les remises",
    location: "Emplacement",
    selectLocations: "Sélectionner les Emplacements",
    companyName: "Nom de l'Entreprise",
    writeCompanyNameHere: "Écrivez ici le nom de l'entreprise",
    billingAddress: "Adresse de Facturation",
    genderPreference: "Préférence de Genre",
    category: "Catégorie",
    enterDescription: "Saisir la Description",
    writeDescriptionOfPlace: "Écrivez la description du lieu",
    addPhotos: "Ajouter des Photos",
    addVideo: "Ajouter une Vidéo",
    addMenu: "Ajouter un Menu",
    payNow: "Payer Maintenant",
    addNewPlace: "Ajouter un Nouveau Lieu",
    title: "Titre",
    writeTitle: "Écrire le Titre",
    price: "Prix",
    writeDealPrice: "Écrire le Prix de l'Offre",
    startDate: "Date de Début",
    selectLocations: "Sélectionner les Lieux",
    selectAvailability: "Sélectionner la Disponibilité",
    addNewPlace: "Ajouter un nouvel endroit",
    myEvents: "Mes Événements",
    specialEvent: "Événement Spécial",
    specialEventText: "Événement Spécial: Représente un événement spécial d'une entreprise d'activités qui organise un programme spécial à un jour spécifique dans son emplacement habituel.",
    done: "Fait",
    addYourSpecialEvent: "Ajoutez votre Événement Spécial",
    place: "Lieu",
    close: "Fermer",
    add: "Ajouter",
    addLocation: "Ajouter un Emplacement",
    streetAddress: "Adresse",
    city: "Ville",
    state: "État/Province",
    zipCode: "Code Postal",
    writeZipCode: "Écrire le Code Postal",
    country: "Pays",
    selectCountry: "Sélectionner le Pays",
    selectState: "Sélectionner l'État",
    selectCity: "Sélectionner la Ville",
    writeStreetAddress: "Écrire l'Adresse",
    discountOffered: "Remise Offerte",
    discountForGroups: "Remise pour les Groupes",
    specficDay: "Jour Spécifique",
    singleUse: "Usage Unique",
    startDate: "Date de Début",
    endDate: "Date de Fin",
    selectDate: "Sélectionner la Date",
    everyDay: "Tous les Jours",
    description: "Description",
    writeDescription: "Écrire la Description",
    addNewCommercial: "Ajouter nouveau Commercial",
    commercial: "Commercial",
    enterCommercialName: "Entrez le nom commercial",
    enterYourPlaceName: "Entrez le nom de votre établissement",
    types: "Types",
    enterDescription: "Entrez la description",
    writeDescription: "Écrivez la description",
    addMedia: "Ajouter des médias",
    payNow: "Payer maintenant",
    editPhotos: "Modifier les photos",
    editVideo: "Modifier la vidéo",
    editMenu: "Modifier le menu",
    editPlace: "Modifier l’établissement",
    itemName: "Nom de l’article",
    from: "De",
    to: "À",
    picture: "Image",
    update: "Mettre à jour",
    pleaseEnterTitle: "Veuillez entrer le titre",
    pleaseEnterItemName: "Veuillez entrer le nom de l’article",
    writeDescription: "Écrivez la description",
    writeDealPrice: "Écrivez le prix de l’offre",
    edit: "Modifier",
    resembelanceFor: "Ressemblance pour",
    availableDiscount: "Remise disponible",
    addDeals: "Ajouter des offres",
    discountOn: "Remise sur",
    restaurantLatest: "Dernières nouveautés du restaurant",
    bestDeals: "Meilleures offres",
    forThisPlaceNoDealsAddedYet: "Aucune offre n’a encore été ajoutée pour cet établissement",
    reviews: "Avis",
    noReviewsAddedYet: "Aucun avis n’a encore été ajouté",
    myPlaces: "Mes lieux",
    price: "Prix",
    onEvery: "Tous les jours",
    from: "De",
    bestDeals: "Meilleures offres",
  },
  // Russian
  RU: {
    myProfile: "Мой профиль", // Профиль (Пользователь)
    "event": "Событие",
  "eventText": "Событие — это деятельность, происходящая в каком-то месте. Они не связаны с конкретными местами и будут отображаться на карте.",

    personalInformation: "Личная информация",
    changePassword: "Изменить пароль",
    premium: "Премиум",
    termsAndConditions: "Условия и положения",
    aboutUs: "О нас",
    feedback: "Обратная связь",
    logOut: "Выйти",
    // Sidebar
    home: "Главная",
    save: "Сохранить",
    commercials: "Коммерческие",
    profile: "Профиль",
    faq: "Часто задаваемые вопросы",
    logOut: "Выйти",
    //home
    hello: "Привет",
    commercialAds: "Коммерческая реклама здесь",
    // Saves Page
    save: "Сохранить",
    recentlySaved: "Недавно сохранённые",
    visited: "Посещённые",
    // Commercials Page
    commercials: "Реклама",
    yourCommercials: "Ваша реклама",
    mostPopular: "Самые популярные",
    recent: "Последние",
    previous: "Предыдущий",
    next: "Следующий",
    placesNearYou: "Места рядом с вами",
    // FAQs
    "faqQuestion1": "Как я могу управлять несколькими локациями одновременно?",
  "faqAnswer1": "Каждой локацией можно управлять и анализировать её индивидуально через My Place.",
  
  "faqQuestion2": "В чем разница между событием и специальным событием?",
  "faqAnswer2": "Событие — это одноразовое мероприятие, которое не проходит в существующем месте, тогда как специальное событие — это уникальное мероприятие, проводимое в уже существующем месте деятельности.",
  
  "faqQuestion3": "Как и кого я могу уведомить о своём событии?",
  "faqAnswer3": "При запуске события или специального события вы можете использовать функцию Push-уведомлений, чтобы выбрать определённый радиус. Пользователи, находящиеся в этом радиусе и согласившиеся получать уведомления для данного сегмента активности, будут уведомлены.",
  
  "faqQuestion4": "Каковы преимущества Premium?",
  "faqAnswer4": "С Premium-аккаунтом у вас есть неограниченные возможности для настройки различных типов скидок на карте, а также возможность загружать увлекательные видео для продвижения своей активности.",

    //auth
    //login
    helloAgain: "Снова здравствуйте!",
    welcomeTo: "С возвращением",
    rememberMe: "Запомнить меня",
    forgottenPassword: "Забыли пароль?",
    login: "Войти",
    dontHaveAccount: "Нет аккаунта?",
    byTappingConfirm: "Нажимая 'подтвердить', вы соглашаетесь с",
    termsOfService: "условиями использования",
    andPrivacyPolicy: "и политикой конфиденциальности",
    signUp: "Зарегистрироваться",
    //signup screen
    signUpToGetStarted: "Зарегистрируйтесь, чтобы начать",
    register: "Зарегистрироваться",
    //forgot password
    forgotPasswordTitle: "Забыли пароль!",
    enterEmailToSearch:
      "Пожалуйста, введите адрес электронной почты для поиска своей учетной записи.",
    backToLogin: "Назад к входу?",
    confirmAction: "Подтвердить",
    verifyCode: "Проверить код",
    resendCode: "Отправить код повторно",
    confirmCode: "Подтвердить",
    enterCodeFromEmail:
      "Введите код, который вы получили на свою электронную почту",
    //reset password
    submit: "Отправить",
    resetPasswordTitle: "Сброс пароля!",
    enterNewPassword:
      "Пожалуйста, введите новый пароль для своей учетной записи",
    success: "Успешно",
    formError: "Ошибка в форме",
    //contributor screen
    // sidebar
    dashboard: "Панель управления",
    myPlaces: "Мои места",
    commercials: "Реклама",
    //dashboard
    analytics: "Аналитика",
    profileVisitors: "Посетители профиля",
    customerReviews: "Отзывы клиентов",
    customerRatio: "Соотношение клиентов",
    reservations: "Бронирования",
    totalVisitors: "Всего посетителей",
    thisYear: "В этом году",
    thisMonth: "В этом месяце",
    todaysCustomerRatio: "Соотношение клиентов сегодня",
    current: "Текущий",
    customersReview: "Отзывы клиентов",
    vsYesterday: "по сравнению со вчерашним днем",
    //my places
    all: "Все",
    approved: "Одобрено",
    pending: "В ожидании",
    rejected: "Отклонено",
    addNew: "Добавить новое",
    addActivityLocation: "Добавить место проведения",
    addYourEvent: "Добавить ваше событие",
    addSpecialEvent: "Добавить специальное событие",
    editPlace: "Редактировать место",
    approvedText: "Одобрено",
    pendingText: "В ожидании",
    rejectedText: "Отклонено",
    //categories
    adventure: "Приключения",
    kids: "Дети",
    culture: "Культура",
    date: "Свидание",
    restaurant: "Ресторан",
    sports: "Спорт",
    countryFairs: "Ярмарки",
    music: "Музыка",
    learning: "Обучение",
    gaming: "Игры",
    animals: "Животные",
    events: "События",
    specialEvents: "Особые события",
    filter: "Фильтр",
    category: "Категория",
    hours: "Часы",
    discount: "Скидка",
    clear: "Очистить",
    apply: "Применить",
    specifyInterest:
      "Укажите ваш интерес, по которому вы хотите получать уведомления",
    notifications: "Уведомления",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmPassword: "Подтвердите пароль",
    writeFeedback: "Напишите свой отзыв здесь",
    //terms and condition
    termsTitle1: "Принятие условий",
    termsParagraph1:
      "Используя наши услуги, вы соглашаетесь с этими условиями. Если вы не согласны, пожалуйста, не используйте наше приложение.",
    termsTitle2: "Изменения условий",
    termsParagraph2:
      "Мы оставляем за собой право изменять эти условия в любое время. Изменения вступают в силу сразу после публикации. Ваше дальнейшее использование приложения означает ваше согласие с пересмотренными условиями.",
    termsTitle3: "Обязанности пользователя",
    termsParagraph3:
      "Пользователи должны использовать приложение ответственно и в соответствии со всеми применимыми законами. Запрещается любое неправомерное использование, включая, но не ограничиваясь, несанкционированным доступом, распространением вредоносного контента или нарушением прав интеллектуальной собственности.",
    termsTitle4: "Регистрация аккаунта",
    termsParagraph4:
      "Для доступа к определённым функциям вы можете быть обязаны создать аккаунт. Вы соглашаетесь предоставлять точную информацию и обеспечивать безопасность своего аккаунта. Вы несёте ответственность за все действия в вашем аккаунте.",
    termsTitle5: "Конфиденциальность",
    termsParagraph5:
      "Ваша конфиденциальность важна для нас. Наша политика конфиденциальности объясняет, как мы собираем, используем и защищаем вашу информацию. Используя приложение, вы соглашаетесь с нашей политикой обработки данных.",
    termsWelcome:
      "Добро пожаловать в приложение Activity Map. Загружая, получая доступ или используя наше приложение, вы соглашаетесь соблюдать и быть связанными следующими условиями:",
    //about us
    aboutUsParagraph1:
      "Добро пожаловать в приложение Activity Map, вашего лучшего помощника в поиске лучших мест и событий вокруг вас. Мы понимаем, что у каждого есть свои уникальные интересы и увлечения, поэтому наше приложение классифицирует мероприятия на различные категории, такие как приключения, дети, культура, рестораны, спорт, обучение, идеи для свиданий и разнообразные события, включая специальные мероприятия.",
    aboutUsParagraph2:
      "Наша миссия — обогатить вашу жизнь, сделав исследование простым и доступным. Будь вы искатель острых ощущений, планирующая веселый день семья, любитель культуры, ищущий обогащающие впечатления, или гурман, ищущий лучшую местную кухню — Activity Map App предложит что-то для каждого.",
    aboutUsParagraph3:
      "Приложение предоставляет подробную информацию и карты, чтобы помочь вам ориентироваться и максимально использовать ваше окружение. Открывайте близлежащие приключения, детские мероприятия, культурные центры, спортивные площадки, образовательные возможности, романтические места для свиданий и широкий спектр событий. Каждая категория тщательно подобрана, чтобы вы имели доступ к наиболее релевантным и захватывающим вариантам.",
    // Form fields
    enterYourPlaceName: "Введите Название Вашего Места",
    writeNameForPlace: "Напишите название места",
    type: "Тип",
    reservationLink: "Ссылка на Бронирование",
    writeReservationLinkHere: "Напишите здесь ссылку на бронирование",
    availability: "Доступность",
    selectAvailability: "Выберите Доступность",
    offeredDiscounts: "Предлагаемые Скидки",
    selectDiscounts: "Выберите скидки",
    location: "Местоположение",
    selectLocations: "Выберите Местоположения",
    companyName: "Название Компании",
    writeCompanyNameHere: "Напишите здесь название компании",
    billingAddress: "Адрес для Выставления Счетов",
    genderPreference: "Гендерные Предпочтения",
    category: "Категория",
    enterDescription: "Введите Описание",
    writeDescriptionOfPlace: "Напишите описание места",
    addPhotos: "Добавить Фото",
    addVideo: "Добавить Видео",
    addMenu: "Добавить Меню",
    payNow: "Оплатить Сейчас",
    addNewPlace: "Добавить Новое Место",
    title: "Заголовок",
    writeTitle: "Написать Заголовок",
    price: "Цена",
    writeDealPrice: "Указать Цена Предложения",
    startDate: "Дата Начала",
    selectLocations: "Выбрать Места",
    selectAvailability: "Выбрать Доступность",
    addNewPlace: "Добавить новое место",
    myEvents: "Мои События",
    specialEvent: "Специальное Событие",
    specialEventText: "Специальное Событие: Означает специальное событие от компании активностей, которая проводит специальную программу в определенный день в своем обычном месте.",
    done: "Готово",
    addYourSpecialEvent: "Добавьте Ваше Специальное Событие",
    place: "Место",
    close: "Закрыть",
    add: "Добавить",
    addLocation: "Добавить Местоположение",
    streetAddress: "Улица",
    city: "Город",
    state: "Штат/Провинция",
    zipCode: "Почтовый Индекс",
    country: "Страна",
    selectCountry: "Выберите Страну",
    selectState: "Выберите Штат",
    selectCity: "Выберите Город",
    writeZipCode: "Введите Почтовый Индекс",
    writeStreetAddress: "Введите Адрес",
    discountOffered: "Предлагаемая Скидка",
    discountForGroups: "Скидка для Групп",
    specficDay: "Определённый День",
    singleUse: "Одноразовое Использование",
    startDate: "Дата Начала",
    endDate: "Дата Окончания",
    selectDate: "Выберите Дату",
    everyDay: "Каждый День",
    description: "Описание",
    writeDescription: "Написать Описание",
    addNewCommercial: "Добавить новый Commercial",
    Commercials: "Коммерческие",
    enterCommericalsName: "Введите название Comerciais",
    enterYourPlaceName: "Введите название вашего места",
    types: "Типы",
    enterDescription: "Введите описание",
    writeDescription: "Напишите описание",
    addMedia: "Добавить Медию",
    payNow: "Оплатить Сейчас",
    editPhotos: "Изменить Фото",
    editVideo: "Изменить Видео",
    editMenu: "Изменить Меню",
    editPlace: "Изменить Место",
    itemName: "Название Item",
    from: "От",
    to: "До",
    picture: "Фото",
    update: "Обновить",
    writeDealPrice: "Введите цену предложения",
    pleaseEnterTitle: "Пожалуйста, введите название",
    pleaseEnterItemName: "Пожалуйста, введите название предложения",
    writeDescription: "Введите описание",
    writeDealPrice: "Введите цену предложения",
    pleaseEnterTitle: "Пожалуйста, введите название",
    pleaseEnterItemName: "Пожалуйста, введите название предложения",
    writeDescription: "Введите описание",
    writeDealPrice: "Введите цену предложения",
    commercial: "Коммерческий",
    enterCommercialName: "Введите коммерческое название",
    enterYourPlaceName: "Введите название вашего заведения",
    types: "Типы",
    enterDescription: "Введите описание",
    writeDescription: "Напишите описание",
    addMedia: "Добавить медиа",
    payNow: "Оплатить сейчас",
    editPhotos: "Редактировать фотографии",
    editVideo: "Редактировать видео",
    editMenu: "Редактировать меню",
    editPlace: "Редактировать заведение",
    itemName: "Название товара",
    from: "От",
    to: "До",
    picture: "Изображение",
    update: "Обновить",
    pleaseEnterTitle: "Пожалуйста, введите заголовок",
    pleaseEnterItemName: "Пожалуйста, введите название товара",
    writeDescription: "Напишите описание",
    writeDealPrice: "Введите цену предложения",
    edit: "Редактировать",
    resembelanceFor: "Сходство для",
    availableDiscount: "Доступная скидка",
    addDeals: "Добавить предложения",
    discountOn: "Скидка на",
    restaurantLatest: "Последние новости ресторана",
    bestDeals: "Лучшие предложения",
    forThisPlaceNoDealsAddedYet: "Для этого заведения еще не добавлены предложения",
    reviews: "Отзывы",
    noReviewsAddedYet: "Пока нет отзывов",
    myPlaces: "Мои места",
    price: "Цена",
    onEvery: "Каждый день",
    from: "От",
    bestDeals: "Лучшие предложения",
  },
  // German (Deutsch)
  DE: {
    myProfile: "Mein Profil", // Profil (Benutzer)
    personalInformation: "Persönliche Informationen",
    "event": "Ereignis",
  "eventText": "Ein Ereignis ist eine Aktivität, die an einem bestimmten Ort stattfindet. Sie sind nicht mit Orten verbunden und werden auf der Karte angezeigt.",
  
    changePassword: "Passwort ändern",
    premium: "Premium",
    termsAndConditions: "Allgemeine Geschäftsbedingungen",
    aboutUs: "Über uns",
    feedback: "Feedback",
    logOut: "Abmelden",
    // Sidebar
    home: "Startseite",
    save: "Speichern",
    commercials: "Werbung",
    profile: "Profil",
    faq: "Häufig gestellte Fragen",
    logOut: "Abmelden",
    //home
    hello: "Hallo",
    commercialAds: "Werbeanzeigen hier",
    // Saves Page
    save: "Speichern",
    recentlySaved: "Kürzlich gespeichert",
    visited: "Besucht",
    // Commercials Page
    commercials: "Werbung",
    yourCommercials: "Deine Werbung",
    mostPopular: "Am beliebtesten",
    recent: "Neueste",
    previous: "Vorherige",
    next: "Nächste",
    placesNearYou: "Orte in deiner Nähe",
    // FAQs
     "faqQuestion1": "Wie kann ich mehrere Standorte gleichzeitig verwalten?",
  "faqAnswer1": "Jeder Standort kann einzeln über My Place verwaltet und analysiert werden.",
  
  "faqQuestion2": "Was ist der Unterschied zwischen einer Veranstaltung und einer Sonderveranstaltung?",
  "faqAnswer2": "Eine Veranstaltung ist eine einmalige Aktivität, die nicht an einem bestehenden Standort stattfindet, während eine Sonderveranstaltung ein einzigartiger Anlass ist, der an einem bestehenden Aktivitätsort veranstaltet wird.",
  
  "faqQuestion3": "Wie und wen kann ich über meine Veranstaltung benachrichtigen?",
  "faqAnswer3": "Beim Start einer Veranstaltung oder Sonderveranstaltung können Sie die Push-Benachrichtigungsfunktion verwenden, um einen bestimmten Radius auszuwählen. Benutzer innerhalb dieses Radius, die zugestimmt haben, Benachrichtigungen für dieses Aktivitätssegment zu erhalten, werden informiert.",
  
  "faqQuestion4": "Welche Vorteile bietet Premium?",
  "faqAnswer4": "Mit einem Premium-Konto haben Sie unbegrenzte Anpassungsmöglichkeiten, um verschiedene Arten von Rabatten auf der Karte anzuzeigen, sowie die Möglichkeit, ansprechende Videos hochzuladen, um Ihre Aktivität zu bewerben.",
  
    //auth
    //login
    helloAgain: "Hallo nochmal!",
    welcomeTo: "Willkommen zurück",
    rememberMe: "Erinnere dich an mich",
    forgottenPassword: "Passwort vergessen?",
    login: "Anmelden",
    dontHaveAccount: "Du hast noch kein Konto?",
    byTappingConfirm: "Mit dem Tippen auf Bestätigen akzeptierst du die",
    termsOfService: "Nutzungsbedingungen",
    andPrivacyPolicy: "und die Datenschutzrichtlinie",
    signUp: "Registrieren",
    //signup screen
    signUpToGetStarted: "Registriere dich, um loszulegen",
    register: "Registrieren",
    //forgot password
    forgotPasswordTitle: "Passwort vergessen!",
    enterEmailToSearch:
      "Bitte gib deine E-Mail-Adresse ein, um nach deinem Konto zu suchen.",
    backToLogin: "Zurück zum Login?",
    confirmAction: "Bestätigen",
    verifyCode: "Code verifizieren",
    resendCode: "Code erneut senden",
    confirmCode: "Bestätigen",
    enterCodeFromEmail: "Gib den Code ein, den du per E-Mail erhalten hast",
    //reset password
    submit: "Absenden",
    resetPasswordTitle: "Passwort zurücksetzen!",
    enterNewPassword: "Bitte gib ein neues Passwort für dein Konto ein",
    success: "Erfolg",
    formError: "Formularfehler",
    //contributor screen
    // sidebar
    dashboard: "Dashboard",
    myPlaces: "Meine Orte",
    commercials: "Werbung",
    //dashboard
    analytics: "Analyse",
    profileVisitors: "Profilbesucher",
    customerReviews: "Kundenbewertungen",
    customerRatio: "Kundenverhältnis",
    reservations: "Reservierungen",
    totalVisitors: "Gesamtbesucher",
    thisYear: "Dieses Jahr",
    thisMonth: "Diesen Monat",
    todaysCustomerRatio: "Kundenverhältnis heute",
    current: "Aktuell",
    customersReview: "Kundenrezensionen",
    vsYesterday: "im Vergleich zu gestern",
    //my places
    all: "Alle",
    approved: "Genehmigt",
    pending: "Ausstehend",
    rejected: "Abgelehnt",
    addNew: "Neu hinzufügen",
    addActivityLocation: "Aktivitätsort hinzufügen",
    addYourEvent: "Füge dein Event hinzu",
    addSpecialEvent: "Spezialevent hinzufügen",
    editPlace: "Ort bearbeiten",
    approvedText: "Genehmigt",
    pendingText: "Ausstehend",
    rejectedText: "Abgelehnt",
    //categories
    adventure: "Abenteuer",
    kids: "Kinder",
    culture: "Kultur",
    date: "Date",
    restaurant: "Restaurant",
    sports: "Sport",
    countryFairs: "Volksfeste",
    music: "Musik",
    learning: "Lernen",
    gaming: "Spiele",
    animals: "Tiere",
    events: "Veranstaltungen",
    specialEvents: "Besondere Veranstaltungen",
    filter: "Filter",
    category: "Kategorie",
    hours: "Stunden",
    discount: "Rabatt",
    clear: "Löschen",
    apply: "Anwenden",
    specifyInterest:
      "Bitte geben Sie Ihr Interessengebiet an, für das Sie Benachrichtigungen erhalten möchten",
    notifications: "Benachrichtigungen",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    writeFeedback: "Schreiben Sie hier Ihr Feedback",
    //terms and condition
    termsTitle1: "Akzeptanz der Bedingungen",
    termsParagraph1:
      "Durch die Nutzung unserer Dienste stimmen Sie diesen Geschäftsbedingungen zu. Wenn Sie nicht einverstanden sind, verwenden Sie bitte unsere App nicht.",
    termsTitle2: "Änderungen der Bedingungen",
    termsParagraph2:
      "Wir behalten uns das Recht vor, diese Bedingungen jederzeit zu ändern. Änderungen treten sofort nach der Veröffentlichung in Kraft. Ihre fortgesetzte Nutzung der App bedeutet, dass Sie die überarbeiteten Bedingungen akzeptieren.",
    termsTitle3: "Verantwortlichkeiten des Nutzers",
    termsParagraph3:
      "Nutzer müssen die App verantwortungsvoll und in Übereinstimmung mit allen geltenden Gesetzen verwenden. Jeglicher Missbrauch, einschließlich, aber nicht beschränkt auf unbefugten Zugriff, Verbreitung schädlicher Inhalte oder Verletzung von Urheberrechten, ist verboten.",
    termsTitle4: "Konto-Registrierung",
    termsParagraph4:
      "Um auf bestimmte Funktionen zuzugreifen, müssen Sie möglicherweise ein Konto erstellen. Sie stimmen zu, genaue Informationen bereitzustellen und Ihr Konto sicher zu halten. Sie sind für alle Aktivitäten in Ihrem Konto verantwortlich.",
    termsTitle5: "Datenschutz",
    termsParagraph5:
      "Ihre Privatsphäre ist uns wichtig. Unsere Datenschutzrichtlinie erklärt, wie wir Ihre Informationen sammeln, verwenden und schützen. Durch die Nutzung der App stimmen Sie unseren Datenpraktiken zu.",
    termsWelcome:
      "Willkommen bei der Activity Map App. Durch das Herunterladen, Zugreifen oder Verwenden unserer App stimmen Sie zu, die folgenden Geschäftsbedingungen einzuhalten und daran gebunden zu sein:",
    //about us
    aboutUsParagraph1:
      "Willkommen bei der Activity Map App, Ihrem erstklassigen Begleiter, um die besten Orte und Veranstaltungen in Ihrer Umgebung zu entdecken. Wir verstehen, dass jeder einzigartige Interessen und Leidenschaften hat, weshalb unsere App Aktivitäten in verschiedene Kategorien einteilt, wie Abenteuer, Kinder, Kultur, Restaurants, Sport, Lernen, Date-Ideen und eine Vielzahl von Veranstaltungen, einschließlich spezieller Events.",
    aboutUsParagraph2:
      "Unsere Mission ist es, Ihr Leben zu bereichern, indem wir die Erkundung einfach und zugänglich machen. Egal, ob Sie ein Adrenalinjunkie sind, der den nächsten Kick sucht, eine Familie, die einen unterhaltsamen Tag plant, ein Kulturliebhaber auf der Suche nach bereichernden Erfahrungen oder ein Feinschmecker auf der Jagd nach der besten lokalen Küche – die Activity Map App bietet für jeden etwas.",
    aboutUsParagraph3:
      "Die App bietet detaillierte Informationen und Karten, die Ihnen helfen, sich zurechtzufinden und das Beste aus Ihrer Umgebung zu machen. Entdecken Sie nahegelegene Abenteuer, kinderfreundliche Aktivitäten, kulturelle Hotspots, Sportstätten, Bildungsmöglichkeiten, romantische Date-Spots und eine breite Palette von Veranstaltungen. Jede Kategorie ist sorgfältig kuratiert, um sicherzustellen, dass Sie Zugang zu den relevantesten und spannendsten Optionen haben.",
    // Form fields
    enterYourPlaceName: "Geben Sie den Namen Ihres Ortes ein",
    writeNameForPlace: "Schreiben Sie den Namen für den Ort",
    type: "Typ",
    reservationLink: "Reservierungslink",
    writeReservationLinkHere: "Schreiben Sie hier den Reservierungslink",
    availability: "Verfügbarkeit",
    selectAvailability: "Verfügbarkeit Auswählen",
    offeredDiscounts: "Angebotene Rabatte",
    selectDiscounts: "Rabatte auswählen",
    location: "Standort",
    selectLocations: "Standorte Auswählen",
    companyName: "Firmenname",
    writeCompanyNameHere: "Schreiben Sie hier den Firmennamen",
    billingAddress: "Rechnungsadresse",
    genderPreference: "Geschlechtspräferenz",
    category: "Kategorie",
    enterDescription: "Beschreibung Eingeben",
    writeDescriptionOfPlace: "Schreiben Sie die Beschreibung des Ortes",
    addPhotos: "Fotos Hinzufügen",
    addVideo: "Video Hinzufügen",
    addMenu: "Menü Hinzufügen",
    payNow: "Jetzt Bezahlen",
    addNewPlace: "Neuen Ort Hinzufügen",
    title: "Titel",
    writeTitle: "Titel Schreiben",
    price: "Preis",
    writeDealPrice: "Angebotspreis Eingeben",
    startDate: "Startdatum",
    selectLocations: "Standorte Auswählen",
    selectAvailability: "Verfügbarkeit Auswählen",
    addNewPlace: "Neuen Ort hinzufügen",
    myEvents: "Meine Veranstaltungen",
    specialEvent: "Besondere Veranstaltung",
    specialEventText: "Besondere Veranstaltung: Stellt eine besondere Veranstaltung eines Aktivitätsunternehmens dar, das an einem bestimmten Tag in seinem gewohnten Standort ein spezielles Programm organisiert.",
    done: "Fertig",
    addYourSpecialEvent: "Fügen Sie Ihre besondere Veranstaltung hinzu",
    place: "Ort",
    close: "Schließen",
    add: "Hinzufügen",
    addLocation: "Standort Hinzufügen",
    streetAddress: "Straße",
    city: "Stadt",
    state: "Bundesland/Provinz",
    zipCode: "Postleitzahl",
    country: "Land",
    selectCity: "Stadt Auswählen",
    selectState: "Bundesland/Provinz Auswählen",
    selectCountry: "Land Auswählen",
    writeZipCode: "Postleitzahl Eingeben",
    writeStreetAddress: "Straßenadresse Eingeben",
    discountOffered: "Angebotener Rabatt",
    discountForGroups: "Rabatt für Gruppen",
    specficDay: "Bestimmter Tag",
    singleUse: "Einmalige Verwendung",
    startDate: "Startdatum",
    endDate: "Enddatum",
    selectDate: "Datum Auswählen",
    everyDay: "Jeden Tag",
    description: "Beschreibung",
    writeDescription: "Beschreibung Schreiben",
    addNewCommercial: "Neuen Commercial hinzufügen",
    commercial: "Gewerblich",
    enterCommercialName: "Geben Sie den Handelsnamen ein",
    enterYourPlaceName: "Geben Sie den Namen Ihres Ortes ein",
    types: "Arten",
    enterDescription: "Geben Sie die Beschreibung ein",
    writeDescription: "Schreiben Sie die Beschreibung",
    addMedia: "Medien hinzufügen",
    payNow: "Jetzt bezahlen",
    editPhotos: "Fotos bearbeiten",
    editVideo: "Video bearbeiten",
    editMenu: "Menü bearbeiten",
    editPlace: "Ort bearbeiten",
    itemName: "Artikelname",
    from: "Von",
    to: "Bis",
    picture: "Bild",
    update: "Aktualisieren",
    pleaseEnterTitle: "Bitte Titel eingeben",
    pleaseEnterItemName: "Bitte Artikelnamen eingeben",
    writeDescription: "Beschreibung schreiben",
    writeDealPrice: "Angebotspreis eingeben",
    edit: "Bearbeiten",
    resembelanceFor: "Ähnlichkeit für",
    availableDiscount: "Verfügbarer Rabatt",
    addDeals: "Angebote hinzufügen",
    discountOn: "Rabatt auf",
    restaurantLatest: "Neuigkeiten aus dem Restaurant",
    bestDeals: "Beste Angebote",
    forThisPlaceNoDealsAddedYet: "Für diesen Ort wurden noch keine Angebote hinzugefügt",
    reviews: "Bewertungen",
    noReviewsAddedYet: "Noch keine Bewertungen hinzugefügt",
    myPlaces: "Meine Orte",
    price: "Preis",
    onEvery: "Jeden Tag",
    from: "Von",
    bestDeals: "Beste Angebote",
  },
};
export const useTranslation = () => {
  const reduxLanguge = useSelector((s) => s?.language?.countryCode ?? "GB");
  const t = (keyname,forceTranslationIn) => {
    return allLanguages?.[forceTranslationIn??reduxLanguge]?.[keyname] ?? keyname;
  };
  return { t };
};
